import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_SUBCONTRACTOR} from '../../constants';

export default {
  id: 'SUPP_FOURN',
  title: 'Wie lösche ich einen Nachunternehmer?',
  description: '',
  categories: [CONTENT_CATEGORY_SUBCONTRACTOR],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Sie können einen Nachunternehmer löschen, sobald das Projekt beendet ist und jederzeit während Ihres Abonnements auf der Plattform. Sie können ihm natürlich eine Einladung schicken, um seine Zertifikate abzuholen.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Gehen Sie auf die Registerkarte " Nachunternehmer "'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_SUPP_FOURN/DE_SUPP_FOURN_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Klicken Sie in der Zeile des Nachunternehmers, den Sie löschen möchten, auf die drei Punkte auf der rechten Seite'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_SUPP_FOURN/DE_SUPP_FOURN_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Dann klicken Sie auf "Firma entfernen".'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_SUPP_FOURN/DE_SUPP_FOURN_3.png`
  }]
};
